import React from 'react';
import { FormField } from './form-field';
export const createFormFields = _ref => {
  let {
    form,
    errors,
    values,
    onFieldChange,
    FieldLayout
  } = _ref;
  return form.fields.map(formField => {
    const component = /*#__PURE__*/React.createElement(FormField, {
      field: formField,
      values: values,
      errors: errors,
      onFieldChange: onFieldChange,
      FieldLayout: FieldLayout
    });
    return {
      id: formField.id,
      fieldType: formField.fieldType,
      component,
      layout: formField.layout
    };
  }).filter(item => !!item);
};
//# sourceMappingURL=create-form-fields.js.map